module.exports = __webpack_public_path__ + "static/media/share_twitter.756f9f6d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/share_twitter.svg
 ** module id = 476
 ** module chunks = 0
 **/